<template>
    <div>
        <v-dialog
            v-model="value"
            class="admin-person-info-change-tel-dialog"
            :title="$t('修改管理员手机')"
            kind="confirm"
            @input="onInput"
        >
            <v-steps :titles="customTitles" :index="currentStep"></v-steps>
            <div v-show="currentStep === 1" class="admin-person-info-change-tel-dialog-content step-one">
                <div v-if="hasConfirmSendMessage" class="has-confirm-send-message-tip">
                    <v-icon name="info" style="width:40px;height:40px;display:block;margin:0 auto;"></v-icon>
                    <div class="send-message-tip-title">{{ $t('未收到您发送到短信，请重新发送') }}</div>
                    <div class="send-message-tip">
                        {{ $t('为了企业信息安全，请通过旧手机号 {tel} 发送短信"666"到100092084082，发送后点击"我已发送"按钮', { tel }) }}
                    </div>
                </div>
                <div v-else class="no-confirm-send-message-tip">
                    <div class="send-message-tip">
                        {{ $t('为了企业信息安全，请通过旧手机号 {tel} 发送短信"666"到100092084082，发送后点击"我已发送"按钮', { tel }) }}
                    </div>
                </div>
            </div>
            <div v-show="currentStep === 2" class="admin-person-info-change-tel-dialog-content step-two">
                <v-form ref="form" :model="form" @submit.prevent="handleSubmit">
                    <v-form-item :rules="formRules.tel" :label="$t('手机号')" name="tel" error-placement="top-right">
                        <v-input v-model="form.tel" kind="simple"></v-input>
                    </v-form-item>
                    <v-form-item
                        :error="captchaErrorInfo"
                        class="captcha-form-item"
                        :label="$t('验证码')"
                        name="captcha"
                        error-placement="top-right"
                        @error="onCaptchaError"
                    >
                        <v-input v-model="form.captcha" class="captcha-input" kind="simple"></v-input>
                        <v-button v-show="isCountdown" status="default" disabled style="width:102px"
                            >{{ $t('{n}s', { n: countdown }) }}</v-button
                        >
                        <v-button v-show="!isCountdown" status="default" style="width:102px" @click="handleGetCaptcha"
                            >{{ $t('获取验证码') }}</v-button
                        >
                    </v-form-item>
                </v-form>
            </div>

            <template v-if="currentStep === 1">
                <div v-if="hasConfirmSendMessage" slot="footer">
                    <v-button
                        status="primary"
                        size="large"
                        :loading="sendStatusLoading"
                        @click="hasSendMessageHandler(true)"
                        >{{ $t('确认') }}</v-button
                    >
                    <v-button size="large" style="margin-left:20px;" @click="hasConfirmSendMessage = false"
                        >{{ $t('取消') }}</v-button
                    >
                </div>
                <div v-else slot="footer">
                    <v-button
                        status="primary"
                        size="large"
                        :loading="sendStatusLoading"
                        @click="hasSendMessageHandler(false)"
                        >{{ $t('我已发送') }}</v-button
                    >
                </div>
            </template>
            <template v-if="currentStep === 2">
                <div slot="footer">
                    <v-button status="primary" size="large" :loading="bindTelLoading" @click="handleBindTel(false)"
                        >{{ $t('确认') }}</v-button
                    >
                    <v-button size="large" style="margin-left:20px;">{{ $t('取消') }}</v-button>
                </div>
            </template>
        </v-dialog>
        <bind-confirm-dialog
            :show.sync="bindTelConfirmDialogVisiable"
            :has-bind-tel-count="hasBindTelCount"
            @on-confirm="handleConfirmBindTel"
        />
        <bind-tip-dialog :show.sync="bindTelTipDialogVisiable" />
    </div>
</template>

<script>
import BindTelMixin from '../mixins/bind-tel-mixin';
import Gateway from '@/utils/Gateway';

export default {
    mixins: [BindTelMixin],
    props: {
        tel: {
            type: String,
            default: '',
            required: true
        }
    },
    data() {
        return {
            customTitles: [this.$t('验证旧手机号'), this.$t('修改手机号')],
            currentStep: 1,
            hasConfirmSendMessage: false,
            sendStatusLoading: false,
            token: ''
        };
    },
    methods: {
        hasSendMessageHandler(isConfirm) {
            this.sendStatusLoading = true;
            Gateway.post('/v1/basic.account.account_web.AccountWeb/verifyMobileSms', {})
                .then(res => {
                    this.currentStep = 2;
                    this.sendStatusLoading = false;
                    this.token = res.token;
                })
                .catch(err => {
                    this.sendStatusLoading = false;
                    this.hasConfirmSendMessage = true;
                    if (isConfirm) {
                        this.$message.error(err.message || this.$t('网络错误'));
                    }
                    // todo
                    throw err;
                });
        }
    }
};
</script>

<style lang="less">
.admin-person-info-change-tel-dialog {
    .v-dialog__container {
        width: 440px;
    }
    .v-dialog__content {
        padding: 45px 0;
    }
    .v-dialog__body {
        margin-top: 20px;
        overflow: hidden;
        .v-dialog__body--left {
            display: block;
        }
    }
    .send-message-tip {
        font-size: 14px;
        line-height: 20px;
        color: #1e2330;
    }
    .send-message-tip-title {
        height: 28px;
        font-weight: 500;
        font-size: 20px;
        line-height: 28px;
        color: #000000;
        margin: 15px auto 10px;
    }
    &-content {
        height: 186px;
        text-align: center;
        padding: 0 34px;
        .no-confirm-send-message-tip {
            transform: translateY(75px);
        }
        .has-confirm-send-message-tip {
            transform: translateY(37px);
        }
        &.step-two {
            transform: translateY(40px);
        }
    }
    .v-form-item__label,
    .v-form-item__input {
        display: inline-block;
        float: none;
    }
    .v-form-item__label {
        width: 50px;
        height: 20px;
        font-size: 14px;
        line-height: 20px;
        color: #1e2330;
        margin: 0;
        text-align: left;
        transform: translateY(-16px);
        label {
            margin: 0;
        }
    }
    .v-input {
        width: 302px;
        .v-input--simple__input {
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 22px;
            color: #1e2330;
        }
    }
    .captcha-input {
        width: 186px;
    }
    .v-dialog__body {
        margin-top: 20px;
    }
    .captcha-form-item {
        .v-form-item__input {
            text-align: justify;
            width: 302px;
            .v-button {
                float: right;
            }
            .v-form-item__trerr {
                transform: translateX(-112px);
            }
        }
    }
}
</style>
